import {
    FieldInCard,
} from 'app/types/form.types'

import {
    GeneralStatusChangeNote,
} from '../../../ContainerNotes.types'
import {
    AuditTrailConfig,
    getChangeConfig, StatusChangeConfig,
} from './notesConfigs'

type Fields = keyof GeneralStatusChangeNote

const fields: FieldInCard<Fields>[] = [
    getChangeConfig(),
    StatusChangeConfig,
    AuditTrailConfig,
]

export default fields
